import { Box } from '@mui/material';

import { PageLoading } from './PageLoading';

type PageLoadingFullscreenProps = {
  readonly msg: string;
};

export const PageLoadingFullscreen = ({ msg }: PageLoadingFullscreenProps) => (
  <Box
    sx={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    {/* translateY is to prevent jumping layout because this component is rendered on empty screen but afterwards we show PageLoading on a page with header and footer */}
    <Box sx={{ transform: 'translateY(-50px)' }}>
      <PageLoading msg={msg} />
    </Box>
  </Box>
);
